module.exports = __webpack_public_path__ + "img/fig16.0172bc8c.jpg";